import { Card, SxProps } from '@mui/material';
import Link from 'next/link';
import { FC, ReactNode, MouseEvent } from 'react';

const cardSx: SxProps = {
    '& a:visited > h3': {
        color: 'info.main',
    },
    '&:hover, &:focus': {
        backgroundColor: 'grey.700',
    },
    backgroundColor: 'common.white',
    padding: 3,
    transition: '.2s ease-in-out',
};

// TODO VOG-951 make ContentCard child of this component
interface SearchCardProps {
    children: ReactNode;
    href: string;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const SearchCard: FC<SearchCardProps> = ({ children, href, onClick }) => (
    <Card data-test-id="saved-search-card" elevation={0} sx={cardSx}>
        <Link href={href} onClick={onClick}>
            {children}
        </Link>
    </Card>
);

export default SearchCard;
